export default __webpack_public_path__ + "static/media/BorderRangeMap.53b41216.jpg";